import { render } from "./EID_DISPLAY.vue?vue&type=template&id=3ebf3a0b"
import script from "./EID_DISPLAY.vue?vue&type=script&lang=js"
export * from "./EID_DISPLAY.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__